export const DateLocale = {
    en: {
        month_names: ['January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'],
        month_names_short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
};

export const getYearRangeFromDate = ( date, range = 1 ) => {
    const _range = parseInt( range );

    if ( typeof date.getFullYear !== 'function' ) {
        throw Error( `[DateUtils:getYearRangeFromToday] expects "date" to be a Date object but got ${date} instead` );
    }

    if ( isNaN( _range ) ) {
        throw Error( `[DateUtils:getYearRangeFromToday] expects "range" to be a number but got ${range} instead` );
    }

    const years = [];
    const thisYear = date.getFullYear();
    let i = 0;

    while ( i <= _range ) {
        years.push( thisYear + i );
        i++;
    }

    return years;
};

/**
 * Date Prototypes
 */
if ( !Date.prototype.getMonthName ) {
    Date.prototype.getMonthName = function ( lang ) {
        lang = lang && (lang in DateLocale) ? lang : 'en';
        return DateLocale[lang].month_names[this.getMonth()];
    };
}

if ( !Date.prototype.getMonthNameShort ) {
    Date.prototype.getMonthNameShort = function ( lang ) {
        lang = lang && (lang in DateLocale) ? lang : 'en';
        return DateLocale[lang].month_names_short[this.getMonth()];
    };
}

/**
 * @param {Date} date -
 * @param {String} format - longName [default] (September, 1), shortName (Sep, 1),
 */
export const parseDatePattern = ( dateString, datePattern ) => {
    var parts = dateString.match( datePattern );
    if ( parts ) {
        parts = parts[1].split( '-' );
        return new Date( parts[0], parts[1] - 1, parts[2] );
    }
    else {
        return null;
    }
};

/**
 * Get integer of the number of days of specified date from today
 * @param {String} date - any date string acceptable by javascript Date object
 * @returns {number} - numberOfDays
 */
export const getNumberOfDaysFromNow = ( date ) => {
    var now = new Date(),
        pastDate = new Date( date );

    if ( 'Invalid Date' === pastDate ) {
        console.error( 'upi.Date.getNumberOfDaysFromNow received Invalid Date string [' + date + ']' );
        return false;
    }

    return Math.floor( (now.getTime() - pastDate.getTime()) / (1000 * 60 * 60 * 24) ) || 0;
};

export const formatDate = ( date, format ) => {
    if ( typeof date === 'string' ) {
        // parse yyyy-mm-dd format - eg. 2014-05-30 00:00:00Z
        var yyyymmddPattern = /(\d{4}-\d{2}-\d{2})/;
        if ( yyyymmddPattern.test( date ) ) {
            date = parseDatePattern( date, yyyymmddPattern );
        }
    }

    if ( !(date instanceof Date) ) {
        date = new Date( date );
    }

    if ( !date || date == 'Invalid Date' ) {
        return null;
    }

    switch ( format ) {
        case 'longNameFull':
            return date.getMonthName() + ' ' + date.getDate() + ', ' + date.getFullYear();
        case 'shortName':
            return date.getMonthNameShort() + ' ' + date.getDate();
        case 'longName':
        default:
            return date.getMonthName() + ' ' + date.getDate();
    }
};
